<template>
	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24" v-if="repair">

		<div class="row">
			<div class="columns">
				<h4>{{repair.order_number}}</h4>
			</div>
			<div class="columns shrink">
				<div class="c-label c-label--secondary c-label--link" @click="trigger('change-status')">
					{{repair.events[0] ? repair.events[0].status.name : ''}}
					<svg class="margin-l-4" xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 512 512"><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
				</div>
			</div>
		</div>
		
		<div class="fs-small color-gray-500 margin-b-16">Verzoek aangemaakt op: {{datetime(repair.created_at, true)}}</div>

		<c-splitbutton class="margin-b-24" :buttons="button" v-if="button.length > 0"></c-splitbutton>


		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Eindklant</span>
			</div>
			<div class="columns small-12 medium-8">
				{{repair.client.parent ? repair.client.parent.name : ''}}
			</div>
		</div>

		<div class="row margin-b-40 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Eindgebruiker</span>
			</div>
			<div class="columns small-12 medium-8">
				{{repair.client.name}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Defect artikel</span>
			</div>
			<div class="columns small-12 medium-8" >
				<div v-for="item in repair.products" :key="item.id">
					<div v-if="item.pickup.is_pickup == 1">
						{{item.name}}
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Serienummer</span>
			</div>
			<div class="columns small-12 medium-8" >
				<div v-for="item in repair.products" :key="item.id">
					<div v-if="item.pickup.is_pickup == 1">
						{{repair.items.filter(i => i.id == item.pickup.item_id).length > 0 ? repair.items.filter(i => i.id == item.pickup.item_id)[0].serial : '' }}
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b-40 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Omschrijving</span>
			</div>
			<div class="columns small-12 medium-8">
				{{repair.description}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Vervangend artikel</span>
			</div>
			<div class="columns small-12 medium-8" >
				<div v-for="item in repair.products" :key="item.id">
					<div v-if="item.pickup.is_pickup == 0">
						{{item.name}}
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Serienummer</span>
			</div>
			<div class="columns small-12 medium-8" >
				<div v-for="item in repair.products" :key="item.id">
					<div v-if="item.pickup.is_pickup == 0">
						{{repair.items.filter(i => i.id == item.pickup.item_id).length > 0 ? repair.items.filter(i => i.id == item.pickup.item_id)[0].serial : '' }}
					</div>
				</div>
			</div>
		</div>
		
		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Ophaaldatum</span>
			</div>
			<div class="columns small-12 medium-8">
				{{datetime(repair.date)}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Ophaallocatie</span>
			</div>
			<div class="columns small-12 medium-8">
				{{$filter.address(repair.address) }}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Referentie</span>
			</div>
			<div class="columns small-12 medium-8">
				{{ repair.your_reference }}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Topdesk nummer</span>
            </div>
            <div class="columns small-12 medium-8">
                {{repair.w_number}}
            </div>
        </div>
	</div>
</template>

<script>
import CSplitbutton from '@components/Splitbutton';
import { mapGetters } from 'vuex';
import Form from '@mixins/Form';

export default {
	mixins: [Form],
	components: { CSplitbutton },
	props:{
		repair: {
			required: true
		},
	},
	methods: {
		datetime(value, hours = false){
			if ( typeof value == 'string' && value.trim() != '' ) {
				let date = new Date(value);

				if ( isNaN(date.getTime()) === false ) {

					if(hours){
						return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric',  hour: 'numeric', minute: 'numeric', hour12: false})
					}
					else {
						return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric'})
					}
				}
			}
		},
		trigger(event) {
			this.$store.dispatch('listener/emit', event);
		},
	},
	computed: {
		...mapGetters({
			can: 'user/can',
		}),
		buttons() {
			const buttons = [];
			this.can('Levering wijzigen') && buttons.push({
				label: 'Bewerken',
				action: () => {
					this.$store.dispatch('listener/emit', 'change-status');
				},
			});

			return buttons;
		},
		button() {
			const button = [];
			this.can('Levering wijzigen') && button.push({
				label: 'Bewerken',
				action: () => {
					this.$store.dispatch('listener/emit', 'change-repair');
				},
			});

			return button;
		},
	},
}
</script>